// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aaa272c7","455":"39fe5a8a","977":"03c978af"}[chunkId] + ".chunk.js";
};